// Multi-engraving validation fix
// This script replaces the theme's faulty multi-engraving validation

document.addEventListener('DOMContentLoaded', function() {
  // Run BEFORE the theme's validation to disable it for multi-engraving
  document.addEventListener('click', function(event) {
    const addToCartButton = event.target.closest('[data-add-to-cart]');
    if (!addToCartButton) return;
    
    const form = addToCartButton.closest('form[data-product-form]');
    if (!form) return;
    
    const isMultiEngraving = form?.dataset.multiEngraving === "true" || form?.dataset.multiEngraving === "1";
    if (!isMultiEngraving) return;
    
    // Temporarily remove the multi-engraving attribute to disable theme's validation
    const originalValue = form.dataset.multiEngraving;
    form.removeAttribute('data-multi-engraving');
    
    let isValid = true;
    let hasVisibleSets = false;
    
    // Check each engraving set
    for (let i = 1; i <= 5; i++) {
      const setContainer = form.querySelector(`.engraving-set[data-index="${i}"]`);
      
      if (setContainer && window.getComputedStyle(setContainer).display !== 'none') {
        hasVisibleSets = true;
        
        const textareaContainer = setContainer.querySelector('.engraving-textarea');
        const fileContainer = setContainer.querySelector('.engraving-file');
        const textInput = setContainer.querySelector('textarea');
        const fileInput = setContainer.querySelector('input[type="file"]');
        const positionInput = form.querySelector(`[name="properties[Position ${i}]"]`);
        
        // Check if textarea container is visible and validate text input
        if (textareaContainer && window.getComputedStyle(textareaContainer).display !== 'none') {
          if (!textInput || !textInput.value.trim()) {
            isValid = false;
            textareaContainer.classList.add('error');
          } else {
            textareaContainer.classList.remove('error');
          }
        } else if (textareaContainer) {
          textareaContainer.classList.remove('error');
        }
        
        // Check if file container is visible and validate file input
        if (fileContainer && window.getComputedStyle(fileContainer).display !== 'none') {
          if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
            isValid = false;
            fileContainer.classList.add('error');
          } else {
            fileContainer.classList.remove('error');
          }
        } else if (fileContainer) {
          fileContainer.classList.remove('error');
        }
        
        // Check position selection
        if (!positionInput || !positionInput.value.trim()) {
          isValid = false;
          const swatchGroup = setContainer.querySelector('.engraving-swatches');
          let swatchError = setContainer.querySelector('.swatch-error-message');
          if (!swatchError && swatchGroup) {
            swatchError = document.createElement('div');
            swatchError.className = 'error-message swatch-error-message';
            swatchError.innerHTML = '<span class="alert-text">Please select a position.</span>';
            swatchGroup.parentNode.insertBefore(swatchError, swatchGroup.nextSibling);
          }
        } else {
          const swatchError = setContainer.querySelector('.swatch-error-message');
          if (swatchError) swatchError.remove();
        }
      }
    }
    
    // If validation failed, prevent submission and restore the attribute
    if (!isValid && hasVisibleSets) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      // Restore the multi-engraving attribute
      form.setAttribute('data-multi-engraving', originalValue);
      
      // Show general error message
      const errorContainer = form.querySelector('[data-cart-errors-container]');
      if (errorContainer) {
        errorContainer.innerHTML = `
          <div class="errors" data-error>
            Please fill in all required fields and select positions for your engravings.
          </div>
        `;
        errorContainer.classList.add('is-visible');
      }
      
      return false;
    } else if (isValid && hasVisibleSets) {
      // Hide any error messages
      const errorContainer = form.querySelector('[data-cart-errors-container]');
      if (errorContainer) {
        errorContainer.classList.remove('is-visible');
      }
      
      // Restore the attribute after a short delay so theme can process normally
      setTimeout(() => {
        form.setAttribute('data-multi-engraving', originalValue);
      }, 100);
      
      // Let the event continue to the theme's handler
    }
  }, true); // Use capture phase to run before theme validation
});

// 22 Oct 2026: homepage slideshow videos - always use the sharp HD file (the 480p phone versions looked blurry)
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('video source[data-src*="SD-480p"], video source[src*="SD-480p"]').forEach(function(source) {
    source.remove();
  });
});

// 22 Oct 2026: personalised made-to-order pieces (tag custom26) - clear delivery + offer messaging
(function () {
  var TAG = 'custom26';
  var PRODUCT_NOTE = 'Made to order: personalised pieces ship separately with a flat €5.95 delivery, so they aren\'t included in free delivery over €45 or the 20% / 30% multibuy offer.';
  var CART_NOTE = 'Your personalised piece is made to order and ships separately with a flat €5.95 delivery. Free delivery over €45 still applies to the rest of your bag.';
  var tagCache = {};

  function isMadeToOrder(handle) {
    if (tagCache[handle] !== undefined) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      tagCache[handle] = (p.tags || []).map(function (t) { return String(t).toLowerCase(); }).indexOf(TAG) !== -1;
      return tagCache[handle];
    }).catch(function () { return false; });
  }

  function noteEl(text, cls) {
    var d = document.createElement('p');
    d.className = 'lynott-mto-note ' + cls;
    d.textContent = text;
    d.style.cssText = 'font-size:13px;line-height:1.45;margin:10px 0;padding:10px 12px;background:#f6e9ea;border-radius:8px;color:#0b0b0b;';
    return d;
  }

  // Product page note under the add to cart button
  function productNote() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    isMadeToOrder(m[1]).then(function (yes) {
      if (!yes || document.querySelector('.lynott-mto-note--product')) return;
      var btn = document.querySelector('form[data-product-form] [data-add-to-cart], form[action*="/cart/add"] [type="submit"]');
      if (!btn) return;
      var anchor = btn.closest('.product__submit, .product-form__buttons, .product__block') || btn.parentElement;
      anchor.parentNode.insertBefore(noteEl(PRODUCT_NOTE, 'lynott-mto-note--product'), anchor.nextSibling);
    });
  }

  // Cart page + cart drawer: replace the "free shipping" promise when a made-to-order piece is in the bag
  var checking = false;
  function cartNote() {
    if (checking) return;
    checking = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var handles = cart.items.map(function (i) { return i.handle; });
      return Promise.all(handles.map(isMadeToOrder));
    }).then(function (flags) {
      var hasMto = flags.some(Boolean);
      document.querySelectorAll('.lynott-mto-note--cart').forEach(function (n) { if (!hasMto) n.remove(); });
      if (!hasMto) return;
      var nodes = document.querySelectorAll('.cart-drawer *, #cart-drawer *, .cart *, [data-cart] *');
      nodes.forEach(function (el) {
        if (el.children.length === 0 && /free shipping will be applied/i.test(el.textContent) && !el.dataset.mtoDone) {
          el.dataset.mtoDone = '1';
          el.textContent = 'Free delivery over €45 on in-stock pieces';
          var holder = el.parentElement;
          if (holder && !holder.querySelector('.lynott-mto-note--cart')) {
            holder.appendChild(noteEl(CART_NOTE, 'lynott-mto-note--cart'));
          }
        }
      });
    }).catch(function () {}).then(function () { checking = false; });
  }

  document.addEventListener('DOMContentLoaded', function () {
    productNote();
    cartNote();
    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(cartNote, 400);
    });
    document.querySelectorAll('#cart-drawer, .cart-drawer, [data-cart-drawer], .cart__content').forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true });
    });
    document.addEventListener('theme:cart:change', cartNote);
    document.addEventListener('cart:updated', cartNote);
  });
})();
